export enum AddLastUpdateToWeights {
  modeB = 'modeB',
}

export enum MenoraInsuranceBannerAbTest {
  modeB = 'modeB',
}

export enum PrioritizeFormProjectsAbTest {
  modeB = 'modeB',
  modeC = 'modeC',
}

export enum ImmediateAvailabilityFilterAbTest {
  modeB = 'modeB',
}

export enum ListingPageInvestorsInfo {
  modeB = 'modeB',
}

export enum HomePageStandaloneBannersV2 {
  modeB = 'modeB',
}

export enum ProExpertLink {
  modeB = 'modeB',
}

export enum TranzilaHostedFields {
  modeB = 'modeB',
}

export enum TranzilaHostedFieldsGooglePay {
  modeB = 'modeB',
}

export enum TranzilaGPayLastCheck {
  modeB = 'modeB',
}

export enum HomePageAiChatWidget {
  modeB = 'modeB',
}

export interface IABTestContext {
  _be_addLastUpdateToWeights?: AddLastUpdateToWeights;
  menoraInsuranceBanner?: MenoraInsuranceBannerAbTest;
  prioritizeFormProjects?: PrioritizeFormProjectsAbTest;
  immediateAvailabilityFilter?: ImmediateAvailabilityFilterAbTest;
  listingPageInvestorsInfo?: ListingPageInvestorsInfo;
  homePageStandaloneBannersV2?: HomePageStandaloneBannersV2;
  proExpertLink?: ProExpertLink;
  tranzilaHostedFields?: TranzilaHostedFields;
  tranzilaHostedFieldsGooglePay?: TranzilaHostedFieldsGooglePay;
  tranzilaGPayLastCheck?: TranzilaGPayLastCheck;
  homePageAiChatWidget?: HomePageAiChatWidget;
}
